import { NgIf } from '@angular/common';
import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CobaltDividerComponent } from '@cae/cobalt-angular/components/divider';
import { CobaltUserMenuProfile } from '@cae/cobalt-angular/components/global-header';
import { CobaltIconComponent, cobaltIconEmailOutline, cobaltIconHelpCircleOutline, cobaltIconPhoneOutline, CobaltIconRegistry, CobaltIconSize } from '@cae/cobalt-angular/components/icon';
import { CobaltLinkComponent } from '@cae/cobalt-angular/components/link';
import {
  COBALT_MODAL_DATA,
  CobaltModalContentDirective,
  CobaltModalRef
} from '@cae/cobalt-angular/components/modal';
import { MonitorService } from '@core/services/monitor/monitor.service';
import { Contact } from '@training/models/contact.model';
import { TrainingEvent } from '@training/models/training/training-event.model';
import { TrainingEventsService } from '@training/services/training-events/training-events.service';
import { DateTime } from 'luxon';
import { map, take } from 'rxjs/operators';

import { HeaderService } from '../header/header.service';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
  styleUrls: ['./contact-dialog.component.less'],
  standalone: true,
  imports: [
    CobaltDividerComponent,
    CobaltIconComponent,
    CobaltLinkComponent,
    CobaltModalContentDirective,
    NgIf,
  ]
})
export class ContactDialogComponent implements OnInit {
  trainingEvent: TrainingEvent;
  contact: Contact;
  user: CobaltUserMenuProfile;
  cobaltIconSize: CobaltIconSize = 'medium';
  displayTrainingStartDate: string;
  displayTrainingStartDateLocale = 'en-US';

  private _destroyRef = inject(DestroyRef);

  constructor(
    public modalgRef: CobaltModalRef<ContactDialogComponent>,
    @Inject(COBALT_MODAL_DATA)
    public data: { contact: Contact; user: CobaltUserMenuProfile },
    private trainingEventService: TrainingEventsService,
    private headerService: HeaderService,
    private monitorService: MonitorService,
    private _cobaltIconRegistry: CobaltIconRegistry,
  ) {
    this._cobaltIconRegistry.registerIcons([
      cobaltIconHelpCircleOutline,
      cobaltIconEmailOutline,
      cobaltIconPhoneOutline,
    ])

    this.contact = data.contact;
    this.user = data.user;
  }

  public ngOnInit(): void {
    if (this.contact.reservationId) {
      this.trainingEventService.trainingEvents$
        .pipe(
          takeUntilDestroyed(this._destroyRef),
          map((trainingEvents: TrainingEvent[]) => {
            return trainingEvents?.find(
              (x) =>
                x.geminiReservationId == this.contact.reservationId ||
                x.reservationId == this.contact.reservationId
            );
          }, take(1))
        )
        .subscribe((evt) => {
          this.trainingEvent = evt;

          this.displayTrainingStartDate = DateTime.fromJSDate(
            this.trainingEvent.startDate
          )
            .setLocale(this.displayTrainingStartDateLocale)
            .toFormat('DDD');
        });
    }
  }

  public closeDialog(): void {
    this.modalgRef.close();
  }

  public logHeap(source: string): void {
    this.monitorService.logEvent({
      name: source,
      properties: {
        user: this.user,
        trainingEvent_Timing: this.trainingEvent?.timing
      }
    });
  }

  public showHelp(): void {
    this.logHeap('Web_Customer_Care_Button_Clicked');
    this.headerService.showHelp();
  }
}
